import { redirectCustomerToUpdateReferenceAccount, shouldRedirectCustomerToUpdateReferenceAccount, } from './initialReferenceAccount';
import { redirectCustomerToUpdateData, shouldRedirectCustomerToUpdateData } from './cdvc';
import { redirectCustomerToUpdateFinancialInformation, shouldRedirectCustomerToUpdateFinancialInformation, } from './financialInformation';
export var MissingData;
(function (MissingData) {
    MissingData["cdvc"] = "cdvc";
    MissingData["financialInformation"] = "financialInformation";
    MissingData["referenceAccount"] = "referenceAccount";
})(MissingData || (MissingData = {}));
export const getCustomerMissingData = ({ customer, isCDVCPage, isFinancialInformationPage, isReferenceAccountUpdatePage, isRegistration, isLogin, isOpenbanking, isCorporate, }) => {
    const unAuthenticatedNavConditions = [
        isCDVCPage,
        isFinancialInformationPage,
        isReferenceAccountUpdatePage,
        isRegistration,
        isLogin,
        isOpenbanking,
        isCorporate,
    ];
    if (unAuthenticatedNavConditions.some((condition) => condition))
        return null;
    if (shouldRedirectCustomerToUpdateReferenceAccount(customer))
        return MissingData.referenceAccount;
    if (shouldRedirectCustomerToUpdateFinancialInformation(customer))
        return MissingData.financialInformation;
    if (shouldRedirectCustomerToUpdateData(customer))
        return MissingData.cdvc;
    return null;
};
const mapMissingDataRedirection = {
    [MissingData.referenceAccount]: redirectCustomerToUpdateReferenceAccount,
    [MissingData.financialInformation]: redirectCustomerToUpdateFinancialInformation,
    [MissingData.cdvc]: redirectCustomerToUpdateData,
};
export const redirectCustomerBasedOnMissingData = (missingProperty) => { var _a; return (_a = mapMissingDataRedirection[missingProperty]) === null || _a === void 0 ? void 0 : _a.call(mapMissingDataRedirection); };
//# sourceMappingURL=customerMissingData.js.map